import { render, staticRenderFns } from "./_base-table.vue?vue&type=template&id=a05f24c6"
import script from "./_base-table.vue?vue&type=script&lang=js"
export * from "./_base-table.vue?vue&type=script&lang=js"
import style0 from "./_base-table.vue?vue&type=style&index=0&id=a05f24c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports